<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title class="d-flex align-items-end w-100 justify-content-between">
          Gelirler Raporu
          <b-card-sub-title
            class="font-medium-2 badge badge-light-success badge-pill px-1"
          >
            {{ year }} Yılı
          </b-card-sub-title>
        </b-card-title>
      </b-card-header>
      <b-table-simple
        responsive
        striped
        bordered
        class="mb-0"
      >
        <b-thead>
          <b-tr>
            <b-th colspan="2">
              Tanım
            </b-th>
            <b-th class="width-200 text-nowrap text-right">
              Toplam Tutar
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template
            v-for="(item,index) in incomesYearly.data"
          >
            <b-tr :key="index">
              <b-th
                colspan="2"
                class="text-primary"
              >
                {{ item.title }}
              </b-th>
              <b-th class="text-primary text-right">
                {{ item.amount | toCurrency }} TL
              </b-th>
            </b-tr>
            <b-tr
              v-for="subitem in item.items"
              :key="'items_' + subitem.id"
            >
              <b-td>{{ subitem.title }}</b-td>
              <b-td class="width-200 text-nowrap text-right">
                {{ subitem.donation_type }}
              </b-td>
              <b-td class="width-200 text-nowrap text-right">
                {{ subitem.amount | toCurrency }} TL
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-th colspan="2">
              Genel Toplam
            </b-th>
            <b-th class="text-right">
              {{ incomesYearly.grandTotal | toCurrency }} TL
            </b-th>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTableSimple, BThead, BTbody, BTh, BTd, BTr, BTfoot, BCardHeader, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue'

export default {
  name: 'IncomesYearly',
  components: {
    BCard,
    BTableSimple,
    BThead,
    BTbody,
    BTfoot,
    BTh,
    BTd,
    BTr,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
  },
  computed: {
    year() {
      return this.$store.getters['directorReports/year']
    },
    incomesYearly() {
      return this.$store.getters['directorReports/incomesYearly']
    },
  },
}
</script>
